/* KineticHike theme · theme.js
   No dependencies. Every feature degrades to a plain link or form post
   when JavaScript is unavailable. */
(function () {
  'use strict';

  var KH = window.KH || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, currency: 'USD', locale: 'en', strings: {} };
  var DRAWER_SECTION = 'cart-drawer';

  function money(cents) {
    try {
      return new Intl.NumberFormat(KH.locale || 'en', { style: 'currency', currency: KH.currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function $(selector, root) { return (root || document).querySelector(selector); }
  function $all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  /* ── cart drawer ── */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.body.classList.add('kh-lock');
    var panel = $('.kh-drawer__panel', drawer);
    if (panel) panel.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('kh-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function applyDrawerHtml(html) {
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-content]', doc);
    var current = $('[data-cart-content]', drawer);
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? String(count) : ''; });
  }

  function sectionsParam() {
    return { sections: DRAWER_SECTION, sections_url: window.location.pathname };
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (opener && drawer && window.location.pathname !== KH.routes.cart) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    var change = event.target.closest('[data-line-change]');
    if (change) {
      event.preventDefault();
      changeLine(change.getAttribute('data-key'), parseInt(change.getAttribute('data-quantity'), 10) || 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  function changeLine(key, quantity) {
    var body = sectionsParam();
    body.id = key;
    body.quantity = quantity;
    fetch(KH.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart && cart.sections) applyDrawerHtml(cart.sections[DRAWER_SECTION]);
      })
      .catch(function () { window.location.href = KH.routes.cart; });
  }

  /* ── add to cart ── */
  function bindBuyForm(form) {
    if (form.hasAttribute('data-bound')) return;
    form.setAttribute('data-bound', '');
    var button = $('[data-buy-button]', form);
    var total = $('[data-buy-total]', form);
    var qty = $('input[name="quantity"]', form);
    var select = $('[data-variant-select]', form);
    var error = $('[data-buy-error]', form);

    function refreshTotal() {
      if (!button || !total) return;
      var unit = parseInt(button.getAttribute('data-unit'), 10) || 0;
      var count = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      total.textContent = money(unit * count);
    }

    if (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        if (button && option) button.setAttribute('data-unit', option.getAttribute('data-price'));
        var now = $('[data-price-now]');
        if (now && option) now.textContent = money(parseInt(option.getAttribute('data-price'), 10) || 0);
        refreshTotal();
      });
    }

    $all('[data-qty]', form).forEach(function (box) {
      box.addEventListener('click', function (event) {
        if (!qty) return;
        var value = Math.max(1, parseInt(qty.value, 10) || 1);
        if (event.target.closest('[data-qty-minus]')) qty.value = Math.max(1, value - 1);
        if (event.target.closest('[data-qty-plus]')) qty.value = value + 1;
        refreshTotal();
      });
    });
    if (qty) qty.addEventListener('input', refreshTotal);

    /* colour swatches: price, button, buy bar, photo and the address follow the chosen colour */
    var swatchName = $('[data-swatch-name]', form);
    $all('input[type="radio"][name="id"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var price = parseInt(input.getAttribute('data-price'), 10) || 0;
        if (button) button.setAttribute('data-unit', String(price));
        if (swatchName) swatchName.textContent = input.getAttribute('data-name') || '';
        var now = $('[data-price-now]');
        if (now) now.textContent = money(price);
        var stickyPrice = $('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(price);
        refreshTotal();
        var media = input.getAttribute('data-media');
        var gallery = $('[data-gallery]');
        if (gallery && gallery.khShowMedia) gallery.khShowMedia(media, input.getAttribute('data-name') || '');
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState(null, '', url.toString());
        } catch (e) { /* older browsers keep the plain address */ }
      });
    });

    form.addEventListener('submit', function (event) {
      if (!drawer || !window.fetch || !window.FormData) return;
      event.preventDefault();
      if (error) error.hidden = true;
      if (button) button.setAttribute('aria-disabled', 'true');

      var data = new FormData(form);
      var extra = sectionsParam();
      data.append('sections', extra.sections);
      data.append('sections_url', extra.sections_url);

      fetch(KH.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
        .then(function (response) { return response.json().then(function (json) { return { ok: response.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) {
            if (error) {
              error.textContent = result.json.description || result.json.message || KH.strings.addError || '';
              error.hidden = false;
            }
            return;
          }
          if (result.json.sections) applyDrawerHtml(result.json.sections[DRAWER_SECTION]);
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .then(function () { if (button) button.removeAttribute('aria-disabled'); });
    });
  }
  $all('form[data-kh-buy]').forEach(bindBuyForm);

  /* ── collection sorting: apply as soon as an option is picked ── */
  $all('[data-sort-form] select').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* ── related products: fetched once the shopper scrolls near them ── */
  $all('[data-recs]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!url || !window.fetch) return;
    var load = function () {
      fetch(url)
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var fresh = $('[data-recs]', new DOMParser().parseFromString(html, 'text/html'));
          if (!fresh || !fresh.children.length) return;
          box.innerHTML = fresh.innerHTML;
          $all('form[data-kh-buy]', box).forEach(bindBuyForm);
        })
        .catch(function () { /* related products are optional */ });
    };
    if ('IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { watcher.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      watcher.observe(box);
    } else {
      load();
    }
  });

  /* ── product gallery (1.7.0): swipe carousel, only the chosen colour's photo ── */
  $all('[data-gallery]').forEach(function (gallery) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $all('[data-gallery-slide]', gallery);
    var thumbs = $all('[data-gallery-thumb]', gallery);
    var count = $('[data-gallery-count]', gallery);
    var bar = $('[data-gallery-bar]', gallery);
    var colorTag = $('[data-gallery-color]', gallery);
    var current = 0;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var visible = function () { return slides.filter(function (slide) { return !slide.hidden; }); };

    function paint() {
      var list = visible();
      if (count) count.textContent = pad(current + 1) + ' / ' + pad(list.length);
      if (bar) {
        if (bar.children.length !== list.length) {
          bar.innerHTML = '';
          list.forEach(function () { bar.appendChild(document.createElement('span')); });
        }
        Array.prototype.forEach.call(bar.children, function (seg, i) { seg.classList.toggle('is-on', i === current); });
      }
      var id = list[current] && list[current].getAttribute('data-media-id');
      thumbs.forEach(function (thumb) { thumb.setAttribute('aria-current', id && thumb.getAttribute('data-media-id') === id ? 'true' : 'false'); });
    }

    function go(index, smooth) {
      var list = visible();
      if (!list.length) return;
      current = (index + list.length) % list.length;
      hydrate($('img', list[current]));
      if (list[current + 1]) hydrate($('img', list[current + 1]));
      track.scrollTo({ left: list[current].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      paint();
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var width = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / width);
        var list = visible();
        if (index !== current && index >= 0 && index < list.length) { current = index; paint(); }
      });
    }, { passive: true });

    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        var list = visible();
        var index = list.findIndex(function (slide) { return slide.getAttribute('data-media-id') === id; });
        if (index !== -1) go(index);
      });
    });

    /* a colour swatch shows its own photo and hides the other colours' photos */
    gallery.khShowMedia = function (mediaId, colorName) {
      var id = String(mediaId);
      var target = slides.filter(function (slide) { return slide.getAttribute('data-media-id') === id; })[0];
      if (target && target.hasAttribute('data-variant-media')) {
        slides.forEach(function (slide) {
          if (slide.hasAttribute('data-variant-media')) slide.hidden = slide !== target;
        });
        thumbs.forEach(function (thumb) {
          if (thumb.hasAttribute('data-variant-media')) thumb.hidden = thumb.getAttribute('data-media-id') !== id;
        });
        var img = $('img', target);
        if (img) { hydrate(img); img.loading = 'eager'; }
        /* the chosen colour always leads the gallery */
        if (track.firstElementChild !== target) track.insertBefore(target, track.firstElementChild);
        var thumbBox = thumbs.length ? thumbs[0].parentNode : null;
        var thumb = thumbs.filter(function (t) { return t.getAttribute('data-media-id') === id; })[0];
        if (thumbBox && thumb && thumbBox.firstElementChild !== thumb) thumbBox.insertBefore(thumb, thumbBox.firstElementChild);
        slides = $all('[data-gallery-slide]', gallery);
        thumbs = $all('[data-gallery-thumb]', gallery);
      }
      if (colorTag && colorName) colorTag.textContent = colorName;
      var list = visible();
      var index = target ? list.indexOf(target) : 0;
      if (bar) bar.innerHTML = '';
      go(index < 0 ? 0 : index, false);
    };

    /* photos 2+ arrive without a src so they never compete with the first photo; this gives them one */
    function hydrate(img) {
      if (!img || !img.hasAttribute('data-later')) return;
      img.removeAttribute('data-later');
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
    }

    /* every photo is fetched right after the page has loaded (and at the first touch), so a swipe never waits */
    var warmed = false;
    var warm = function () {
      if (warmed) return;
      warmed = true;
      $all('img[loading="lazy"]', gallery).forEach(function (img) { hydrate(img); img.loading = 'eager'; img.decoding = 'async'; });
    };
    if (document.readyState === 'complete') setTimeout(warm, 200);
    else window.addEventListener('load', function () { setTimeout(warm, 200); });
    track.addEventListener('touchstart', warm, { passive: true, once: true });
    track.addEventListener('pointerenter', warm, { once: true });

    /* a page opened on a colour (?variant=…) also starts with that colour's photo */
    var opened = slides.filter(function (slide) { return slide.hasAttribute('data-variant-media') && !slide.hidden; })[0];
    if (opened && track.firstElementChild !== opened) gallery.khShowMedia(opened.getAttribute('data-media-id'));

    paint();
  });

  /* ── buy bar (phones): shown from the first paint, hidden only while the main button is on screen ── */
  var sticky = $('[data-sticky-buy]');
  var mainButton = $('[data-buy-main] [data-buy-button]');
  if (sticky && mainButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-hidden', entry.isIntersecting); });
    }, { rootMargin: '0px 0px -72px 0px' }).observe(mainButton);
  }

  /* ── help centre search ── */
  var helpForm = $('[data-help-search]');
  if (helpForm) {
    var helpInput = $('input', helpForm);
    var helpEmpty = $('[data-help-empty]');
    var filter = function () {
      var term = (helpInput.value || '').trim().toLowerCase();
      var shown = 0;
      $all('[data-help-group]').forEach(function (group) {
        var visible = 0;
        $all('details', group).forEach(function (item) {
          var match = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
          item.hidden = !match;
          if (match) visible += 1;
          if (term && match) item.open = true;
        });
        group.hidden = visible === 0;
        shown += visible;
      });
      if (helpEmpty) helpEmpty.hidden = shown !== 0;
    };
    helpInput.addEventListener('input', filter);
    helpForm.addEventListener('submit', function (event) { event.preventDefault(); filter(); });
  }

  /* ── order tracking ── */
  var trackForm = $('[data-track-form]');
  if (trackForm) {
    var trackInput = $('input', trackForm);
    try {
      var preset = new URLSearchParams(window.location.search).get('tracking');
      if (preset && trackInput) trackInput.value = preset;
    } catch (e) { /* older browsers: nothing to prefill */ }
    trackForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var number = (trackInput.value || '').replace(/\s+/g, '');
      if (!number) { trackInput.focus(); return; }
      var base = trackForm.getAttribute('data-tracker') || '';
      window.open(base + encodeURIComponent(number), '_blank', 'noopener');
    });
  }

  /* ── policy pages: give each section heading the id its "on this page" link points to ── */
  $all('.shopify-policy__body h2').forEach(function (heading, index) {
    var link = $('[data-kh-toc="' + (index + 1) + '"]');
    if (heading.id && link) link.setAttribute('href', '#' + heading.id);
    if (!heading.id) heading.id = 'kh-sec-' + (index + 1);
    var number = /^(\d+\.)\s+(.*)$/.exec(heading.textContent);
    if (number && !heading.children.length) {
      var mark = document.createElement('span');
      mark.className = 'kh-policy-num';
      mark.textContent = number[1];
      heading.textContent = ' ' + number[2];
      heading.insertBefore(mark, heading.firstChild);
    }
  });

  /* ── phone menu sheet (1.7.0): sits under the header bar, locks the page, closes on a tap, Escape or link ── */
  $all('[data-menu]').forEach(function (menu) {
    var root = document.documentElement;
    var place = function () {
      var bar = menu.closest('.kh-header__bar') || menu.parentNode;
      var bottom = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
      root.style.setProperty('--kh-sheet-top', bottom + 'px');
    };
    menu.addEventListener('toggle', function () {
      if (menu.open) place();
      root.classList.toggle('kh-locked', menu.open);
    });
    $all('a', menu).forEach(function (link) {
      link.addEventListener('click', function () { menu.open = false; });
    });
    $all('[data-menu-close]', menu).forEach(function (btn) {
      btn.addEventListener('click', function () { menu.open = false; var s = $('summary', menu); if (s) s.focus(); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) { menu.open = false; var s = $('summary', menu); if (s) s.focus(); }
    });
    window.addEventListener('resize', function () { if (menu.open) place(); });
  });
})();

/* Filter drawer: a <details> panel; the close button and Escape shut it, and the page behind does not scroll. */
(function () {
  document.querySelectorAll('[data-filter]').forEach(function (d) {
    var close = d.querySelector('[data-filter-close]');
    if (close) close.addEventListener('click', function () { d.open = false; });
    d.addEventListener('toggle', function () { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    d.addEventListener('click', function (e) { if (e.target === d) d.open = false; });
  });
})();

/* 1.6.0 category blocks: NOAA dial, flood-to-spot slider, carry-on check */
(function () {
  document.querySelectorAll('[data-noaa]').forEach(function (root) {
    var freq = root.querySelector('[data-noaa-freq]'), wx = root.querySelector('[data-noaa-wx]'), needle = root.querySelector('[data-noaa-needle]');
    root.querySelectorAll('.kh-noaa__ch').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.kh-noaa__ch').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        freq.textContent = b.dataset.freq; wx.textContent = b.dataset.wx;
        needle.style.setProperty('--x', b.style.getPropertyValue('--x'));
      });
    });
  });
  document.querySelectorAll('[data-beam]').forEach(function (frame) {
    var r = frame.querySelector('input[type="range"]');
    if (!r) return;
    var set = function () { frame.style.setProperty('--x', r.value + '%'); };
    r.addEventListener('input', set); set();
  });
  document.querySelectorAll('[data-calc]').forEach(function (root) {
    var mahIn = root.querySelector('[data-calc-mah]'), vIn = root.querySelector('[data-calc-v]');
    var whOut = root.querySelector('[data-calc-wh]'), formula = root.querySelector('[data-calc-formula]');
    var segs = root.querySelectorAll('.kh-calc__bar i'), mark = root.querySelector('[data-calc-mark]');
    var verdict = root.querySelector('[data-calc-verdict]'), title = root.querySelector('[data-calc-title]'), sub = root.querySelector('[data-calc-sub]');
    var presets = root.querySelectorAll('[data-calc-preset]'), d = root.dataset;
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
    presets.forEach(function (b) { b.textContent = fmt(b.dataset.calcPreset); });
    var run = function () {
      var mah = parseInt(String(mahIn.value).replace(/[^0-9]/g, ''), 10) || 0, v = parseFloat(vIn.value) || 3.7;
      var wh = mah * v / 1000, level = wh <= 100 ? 'ok' : (wh <= 160 ? 'warn' : 'stop');
      whOut.textContent = wh.toFixed(1);
      formula.textContent = fmt(mah) + ' mAh × ' + v + ' V ÷ 1,000 = ' + wh.toFixed(1) + ' Wh';
      segs.forEach(function (s, i) { var on = i === 0 || (i === 1 && wh > 100) || (i === 2 && wh > 160); s.className = on ? 'is-on is-' + level : ''; });
      mark.style.setProperty('--p', Math.min(100, wh / 2) + '%');
      verdict.className = 'kh-calc__verdict is-' + level;
      title.textContent = d['t' + level.charAt(0).toUpperCase() + level.slice(1)];
      sub.textContent = d['t' + level.charAt(0).toUpperCase() + level.slice(1) + 'Sub'];
      presets.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.calcPreset === mah)); });
    };
    mahIn.addEventListener('input', run);
    mahIn.addEventListener('blur', function () { var n = parseInt(String(mahIn.value).replace(/[^0-9]/g, ''), 10); if (n) mahIn.value = fmt(n); });
    vIn.addEventListener('change', run);
    presets.forEach(function (b) { b.addEventListener('click', function () { mahIn.value = fmt(b.dataset.calcPreset); run(); }); });
    mahIn.value = fmt(parseInt(mahIn.value, 10) || 0); run();
  });

  /* Estimated delivery: "6–12 business days" becomes "Arrives Nov 9 – 17".
     Same rules as Merchant Center: business days (Mon–Fri), orders after 12:00 Amsterdam time start the next business day. */
  (function () {
    function amsterdamNow() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false }).formatToParts(new Date());
        var v = {};
        parts.forEach(function (p) { v[p.type] = p.value; });
        return { date: new Date(Date.UTC(+v.year, +v.month - 1, +v.day, 12)), hour: +v.hour % 24 };
      } catch (e) {
        var d = new Date();
        return { date: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12)), hour: d.getHours() };
      }
    }
    function isWeekend(d) { var w = d.getUTCDay(); return w === 0 || w === 6; }
    function addBusinessDays(d, n) {
      var x = new Date(d.getTime());
      while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (!isWeekend(x)) n--; }
      return x;
    }
    function fmt(d, withMonth) {
      return withMonth
        ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
        : String(d.getUTCDate());
    }
    function paint(root) {
      var nodes = Array.prototype.slice.call((root || document).querySelectorAll('[data-eta]:not([data-eta-done])'));
      if (!nodes.length) return;
      var now = amsterdamNow();
      var start = now.date;
      if (isWeekend(start) || now.hour >= 12) { start = addBusinessDays(start, 1); }
      nodes.forEach(function (el) {
        var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
        if (!(min > 0) || !(max >= min)) return;
        var a = addBusinessDays(start, min), b = addBusinessDays(start, max);
        var sameMonth = a.getUTCMonth() === b.getUTCMonth();
        var range = fmt(a, true) + ' – ' + fmt(b, !sameMonth);
        el.textContent = (el.hasAttribute('data-short') ? '' : 'Arrives ') + range;
        el.title = min + '–' + max + ' business days';
        el.setAttribute('data-eta-done', '');
      });
    }
    paint(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { paint(document); }).observe(document.body, { childList: true, subtree: true });
    }
  })();
})();
